/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SystemAnnouncement } from '../models/SystemAnnouncement';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemAnnouncementService {
    /**
     * Gets the system announcement displayed in the portal
     * @returns SystemAnnouncement successful response
     * @throws ApiError
     */
    public static getSystemAnnouncement(): CancelablePromise<SystemAnnouncement> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/systemAnnouncement',
            errors: {
                400: `some error occurred during processing`,
            },
        });
    }
}
